function getComponentClosestLanguage(element) {
  let closestElement = element.closest('[lang]');
  return closestElement ? closestElement.lang : 'es';
}
function getComponentClosestLanguageForPixo(element) {
  let lang = getComponentClosestLanguage(element);
  if (!lang)
    return 'en-US';
  switch (lang) {
    case 'es':
      return 'es-ES';
    case 'fr':
      return 'fr-FR';
    case 'br':
      return 'pt-BR';
    case 'ru':
      return 'ru-RU';
    default:
      return 'en-US';
  }
}
function fetchLocaleStringsForComponent(componentName, locale) {
  return new Promise((resolve, reject) => {
    fetch(`assets/langs/${componentName.replace('gnx-socialnetwork-', '')}.i18n.${locale}.json`).then(result => {
      if (result.ok)
        resolve(result.json());
      else
        reject();
    }, () => reject());
  });
}
async function getLocaleComponentStrings(element) {
  let componentName = element.tagName.toLowerCase();
  let componentLanguage = getComponentClosestLanguage(element);
  let strings;
  try {
    strings = await fetchLocaleStringsForComponent(componentName, componentLanguage);
  }
  catch (e) {
    console.warn(`no locale for ${componentName.replace('gnx-socialnetwork-', '')} (${componentLanguage}) loading default locale en.`);
    strings = await fetchLocaleStringsForComponent(componentName, 'es');
  }
  return strings;
}

export { getComponentClosestLanguageForPixo as a, getLocaleComponentStrings as g };
